import { createRequest } from "helpers/tools";

export const deleteDestination = async (id) => {
    return await createRequest({
        suffix: `destinations/${id}`,
        method: "delete",
        handleError: false,
    });
};

export const deleteDestinationFromTracker = async (
    tracker_id,
    destination_id,
    is_delete,
) => {
    let suffix = `trackers/${tracker_id}/destinations/${destination_id}`;
    if (is_delete !== undefined && is_delete === true) {
        suffix = suffix + "?delete_everywhere=1";
    }
    return await createRequest({
        suffix,
        method: "delete",
        handleError: false,
    });
};
